import { Component } from '@angular/core';

@Component({
    standalone: false,
    selector: 'mhv-root',
    templateUrl: './root-container.component.html'
})
export class RootContainerComponent {}
